import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { buscarDetalle } from '../../servicios/publicacionesService'
import styles from '../Publicaciones.module.css'
import AdministrarPublicacion from './AdministrarPublicacion'

const Detalle = () => {
  const [publicacion, setPublicacion] = useState({})
  const { idPublicacion } = useParams()
  const navigate = useNavigate()
  const idUsuario = parseInt(localStorage.getItem('idUsuario'))

  const obtenerPublicacion = async () => {
    try {
      const { data } = await buscarDetalle(idPublicacion)
      if (data && (data.idVendedor === idUsuario || data.idPerfil === idUsuario)) {
        setPublicacion(data)
      } else {
        navigate('/Publicaciones/Administrar')
      }
    } catch {
      navigate('/Publicaciones/Administrar')
    }
  }

  useEffect(() => {
    obtenerPublicacion()
  }, [idPublicacion])

  return (
    <fieldset className={`fieldset ${styles.fieldset}`}>
      <div className={styles.headerPublicaciones}>
        <div className={styles.legendWrapper}>
          <legend>{publicacion.titulo}</legend>
        </div>
      </div>
      <AdministrarPublicacion
        publicacion={publicacion}
        setPublicacion={setPublicacion}
        idPublicacion={idPublicacion}
      />
    </fieldset>
  )
}

Detalle.propTypes = {
  entidad: PropTypes.shape({
    idPublicacion: PropTypes.number.isRequired
  }).isRequired,
  actualizarPantallaDetalle: PropTypes.func.isRequired,
  onActualizarPantalla: PropTypes.func.isRequired,
  idPublicacion: PropTypes.number.isRequired
}

export default Detalle
